<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  mounted(){
    let hostname = location.hostname
    let hash = location.hash
     console.log(location.href)
     console.log(location.protocol)
     console.log(hostname)
     console.log(location.hash)
    if(hostname.indexOf('cdwc') > -1 && hash.length < 3){
      this.$router.push('/chang_du/index')
    }else if(hostname.indexOf('dstar') > -1 && hash.length < 3){
      this.$router.push('/dragon_star/index')
    }
  }
}
</script>
<style>
#app {
  font-family:"Microsoft YaHei", 微软雅黑, MicrosoftJhengHei, 华文细黑, STHeiti, MingLiu;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  color: #221715;
}
</style>
